<template>
  <div class="offer">
    <div class="container">
      <div class="section-title">
        <h2>{{offerCarousel.head}}</h2>
        <router-link :to="offerCarousel.link" class="section-shop-btn" >shop more <i class="fa fa-angle-right"></i></router-link>
      </div>
      <offer-owl-carousel
        :data="offerCarousel.data"
        :items="offerCarousel.items"
        :margin="offerCarousel.margin"
        :loop="offerCarousel.loop"
        :autoplay="offerCarousel.autoplay"
        :nav="offerCarousel.nav"
        :navText="offerCarousel.navText"
        :responsive="offerCarousel.responsive"
        :dots="offerCarousel.dots"
      />
    </div>
  </div>
</template>


<script>
  export default {
    data () {
      return {
        offerCarousel: {
          head: 'offer products',
          link: '/offer',
          data: [
            {
              img : "https://bit.ly/2Tp8nZB",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2VwFMz4",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            }

          ],
          items    : 4,
          margin   : 15,
          loop     : true,
          autoplay : false,
          nav      : true,
          dots     : false,
          navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
          responsive:{
            0:{
              items:1,
              nav:false
            },
            640:{
              items:2,
              nav:true
            },
            992:{
              items:3,
              nav:true,
            },
            1199:{
              items:4,
              nav:true
            }
          }
        }

      }
    }
  }
</script>


<style >
  .offer{
    padding: 60px 0;
  }
</style>

